module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-column-container",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('navbar', {
    staticStyle: {
      "height": "50px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h-100 flex-column-container"
  }, [_c('online-roundtable-index', {
    staticClass: "h-100"
  })], 1), _vm._v(" "), (_vm.welcome_modal) ? _c('pl-dialog', {
    attrs: {
      "height": "auto",
      "maxHeight": "400px",
      "minWidth": "600px",
      "padding": "2em",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        _vm.welcome_modal = false
      }
    }
  }, [_c('div', {
    staticClass: "ph3 flex-column-container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "margin": "20px auto"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": "parlay_logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tc pl-subheading mb3"
  }, [_c('strong', [_vm._v("\n          Welcome to Parlay's Online RoundTable Interactive Demo!\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "pl-subheading ph4 pv3 tc w-70 br3 shadow-1",
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "interactive-demo-dot center mb2"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-auto pl-body-1"
  }, [_vm._v("\n            Click on the pink information buttons to learn about a feature\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex mt3 center"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        _vm.welcome_modal = false
      }
    }
  }, [_vm._v("\n          Got it!\n        ")])], 1)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-194b2251!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/onlineWalkthrough.index.vue
// module id = 1919
// module chunks = 61